/**
* @author Camilo
* @since  01/02/2018
**/
export class ResolucionModel{

	public constructor(
		public cnumcont:string,
		public cprefijo:string,
		public vresolucion:string,
		public ndesde:number,
		public nhasta:number,
		public nmesesresolucion:number,
		public dfechaexpedicion:Date,
		public dfechavencimiento:Date,
		public nestado:number
		){}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Resoluciones/Resolucion.model.ts